import CornerButtons from "@/components/corner-buttons";
import styles from "@/components/secondary-screen.module.css";
import Shortcuts from "@/components/shortcuts";
import * as signals from "@/signals";
import clsx from "clsx";
import { JSX } from "react";

function SecondaryScreen(): JSX.Element {
	return (
		<div
			className={clsx(
				styles["secondary-screen"],
				!signals.isClosingSecondaryScreen.value && "fade-in",
				signals.isClosingSecondaryScreen.value && "fade-out",
			)}
		>
			<CornerButtons />
			<Shortcuts />
		</div>
	);
}

export default SecondaryScreen;
